export default function calculateCenter(stores) {
  if (!stores || stores.length === 0) {
    return {lat: 0, lng: 0}
  }

  const count = stores.length
  return stores.reduce(
    (last, store) => {
      const lat = store.address.location.lat / count
      const lng = store.address.location.lng / count
      return {lat: last.lat + lat, lng: last.lng + lng}
    },
    {lat: 0, lng: 0}
  )
}
